import React from 'react';
import { dataSyncStore } from '../../stores/DataSyncStore';
import DataSyncForm from './components/DataSyncForm';
import { useHistory } from 'react-router-dom';
import { DataSyncItem } from '../../types/DataSyncItem';
import { showToasts } from '../../lib/toaster';
import { SegmentAnalytics } from '../../lib/SegmentAnalytics';

const CreateDataSyncPage = () => {
  const [dataSync] = React.useState(DataSyncItem.createEmpty());
  const history = useHistory();

  const onSubmit = async (syncObj: DataSyncItem) => {
    await SegmentAnalytics.track('Data Sync Action', {
      action: 'Create',
      path: window.location.pathname + window.location.search,
    });
    // Let errors propagate to useDataSyncSave, which owns the loading state and
    // surfaces the failure. Swallowing here leaves the save spinner stuck.
    await dataSyncStore.createDataSync(syncObj);
    history.push('/data_syncs');
    showToasts([{intent: 'success', message: 'Data sync created successfully'}]);
  };

  const onCancel = () => {
    history.push('/data_syncs');
  };

  return (
    <DataSyncForm mode="create" initialValues={dataSync} onSubmit={onSubmit} onCancel={onCancel}/>
  );
};

export default CreateDataSyncPage;
